import moment from "moment";
import { DeliveryComment } from "src/swagger-gen/lng/models";

export class DeliveryCommentModel {
    uid: string;
    comment: string;
    datetime: string;
    user: string;
    type: string;
    editMode: boolean = false;
    loading: boolean = false;

    constructor(deliveryComment: DeliveryComment){
        this.uid = deliveryComment.uid;
        this.comment= deliveryComment.comment;
        this.datetime = moment(deliveryComment.datetime).format("DD/MM/YYYY HH:mm");
        this.user = `${deliveryComment.firstname} ${deliveryComment.lastname}`;
        this.type = `users.role.${deliveryComment.type}`;
    }
}